import React, { useState } from "react";
import MemoPopup from "./MemoPopup";

const MemoItem = ({ m, index, saveMemo }) => {
  const [memoText, setMemoText] = useState(m.mdcnMemo || "");

  return (
    <div>
      {/* 날짜 박스 */}
      <div className="timebox">
        <span className="fir-date">
          <u>{m.yyyy}</u>
          {m.mmdd}
        </span>
      </div>

      {/* 메모 팝업 포함 */}
      <MemoPopup
        memoText={memoText}
        mdcnDt={m.dt.substr(0, 10)}
        setMemoText={setMemoText}
        saveMemo={saveMemo}
        m={m}
      />
    </div>
  );
};

export default MemoItem;
